import {MODAL_WIDTH_LG} from '../../../../styles/constants';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {getAttributeFileRowListCsvRows, hideAttributeFileRowList} from './actions';
import EnhancedModal from '../../../../components/enhanced-modal';
import {Button} from "antd";
import {getFilterObjFromViewerObj} from "../../../../utils/filter";
import InfiniteScrollDataTable from "../../../../components/infinite-scroll-data-table";

const mapStateToProps = state => ({
  isVisible: state.scenes.dataManager.attributeFile.components.rowList.isVisible,
  separator: state.scenes.dataManager.attributeFile.shared.separator,
  delimiter: state.scenes.dataManager.attributeFile.shared.delimiter,
  csvServerPath: state.scenes.dataManager.attributeFile.shared.csvServerPath,
  tid: state.scenes.dataManager.attributeFile.shared.tid,
  csvRows: state.scenes.dataManager.attributeFile.components.rowList.csvRows,
});

const mapDispatchToProps = dispatch => ({
  onHide: () => dispatch(hideAttributeFileRowList()),
  fetchCsvRows: (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, tid, filePath) =>
    dispatch(getAttributeFileRowListCsvRows(pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, tid, filePath))
});

const AttributeFileRowList = ({
                                      t,
                                      isVisible,
                                      tid,
                                      separator,
                                      delimiter,
                                      csvServerPath,
                                      csvRows,
                                      onHide,
                                      fetchCsvRows
                                    }) =>
  <EnhancedModal
    visible={isVisible}
    onCancel={onHide}
    title={t('scenes.dataManager.attributeFile.rowList.title')}
    width={MODAL_WIDTH_LG}
    footer={<Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>}
  >
    {csvServerPath !== null && (
      <InfiniteScrollDataTable
        data={csvRows && csvRows.Data}
        rowTotal={csvRows && csvRows.Count}
        cols={csvRows && csvRows.Columns}
        hiddenCols={['NumRow']}
        onChange={
          ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => fetchCsvRows(
            pageNum,
            pageSize,
            getFilterObjFromViewerObj(
              csvRows &&
              csvRows.Columns.filter(colName => colName !== 'NumRow'),
              searchText,
              filters
            ),
            sortCol ? [sortCol] : null,
            sortByDesc,
            separator,
            !!delimiter ? delimiter : null,
            tid,
            csvServerPath
          )
        }
      />
    )}
  </EnhancedModal>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(AttributeFileRowList);
